import { Accordion, AccordionDetails, Grid } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { AccordionTitle } from 'shell/components/shared/accordion-title';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import FlagValidationFiscalCode from 'shell/components/shared/flag-validation-fiscal-code/flag';
import { noop } from 'shell/utils/noop';
import { AccordionEditDataControl } from 'shell/view-models/edit-data-control';

interface EditDataComponentProps {
  form: AccordionEditDataControl | undefined;
}

const EditDataComponent = ({ form }: EditDataComponentProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-edit-data-control-content"
        id="panel-person-edit-data-control-header"
        expandIcon={<ExpandMore />}
      >
        <AccordionTitle>Dati di controllo modifica</AccordionTitle>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <DatePicker
              label="Data decorrenza"
              disabled
              renderInput={(params) => (
                <PmiTextField {...params} fullWidth error={false} helperText="" />
              )}
              onChange={noop}
              value={form?.dateValidity || null}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FlagValidationFiscalCode disabled value={form?.flag || ''} onChange={noop} />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

EditDataComponent.displayName = 'Accordion Other Citizenship component';

const EditData = memo(EditDataComponent);

export default EditData;
